const theme = {
  colors: {
    white: "#fff",
    black: "#2D3748",
    disabled: "#DADADA",
    gray700: "#555",
    gray400: "#A0AEC0",
    gray200: "#E2E8F0",
    gray100: "#f2f2f2",
    gray900: "#222",
    gray50: "#F8F9FA",
    gray: "#999",
    red: "#FF405B",
    dark: "#262F37",
    beige: "#f5f1eb",
    primary: {
      focus: "#111",
      hover: "#333",
      active: "#222",
      light: "#555",
      default: "#111",
    },
    secondary: {
      focus: "#BA0B0B",
      hover: "#D32F2F",
      active: "#9A0007",
      default: "#f44336",
    },
    terciary: {
      focus: "#6A1B7A",
      hover: "#AB47BC",
      active: "#7B1FA2",
      default: "#9c27b0",
    },
    success: {
      focus: "#388E3C",
      hover: "#66BB6A",
      active: "#2E7D32",
      default: "#4CAF50",
      light: "#81C784",
      dark: "#2E7D32",
    },
    warning: {
      focus: "#F9A825",
      hover: "#FFD54F",
      active: "#FFB300",
      default: "#FFD600",
      light: "#FFECB3",
      dark: "#F57F17",
    },
    info: {
      focus: "#1976D2",
      hover: "#64B5F6",
      active: "#1565C0",
      default: "#2196F3",
      light: "#90CAF9",
      dark: "#0D47A1",
    },
    darkeen: {
      focus: "#2D3748",
      hover: "#4A5568",
      active: "#1A202C",
      default: "#2D3748",
    },
    whiteen: {
      focus: "#fff",
      hover: "#E2E8F0",
      active: "#f2f2f2",
      default: "#fff",
    },
    status: {
      new: {
        color: "#01878E",
        background: "#E0F8F9",
      },
      replied: {
        color: "#25B000",
        background: "#DAF2D4",
      },
      read: {
        color: "#CE9400",
        background: "#FAECCA",
      },
      private: {
        color: "#555",
        background: "#EDEDED",
      },
    },
    category: {
      blue: "#1F67C9",
      red: "#E63A52",
      gray: "#555555",
      green: "#25B000",
    },
    messages: {
      sent: "#d9fdd3",
      received: "#fff",
    },
  },
  fonts: {
    body: "'Roboto', sans-serif",
    heading: "'Roboto', sans-serif",
  },
  media: {
    sm: "screen and (max-width: 576px)",
    md: "screen and (max-width: 768px)",
    lg: "screen and (max-width: 992px)",
    xl: "screen and (max-width: 1200px)",
  },
};

export default theme;
